import script from "./projectDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./projectDetail.vue?vue&type=script&lang=ts&setup=true"

import "./projectDetail.vue?vue&type=style&index=0&id=9d13c494&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d13c494"]])

export default __exports__